<template>
  <div class="bb-popup bb-popup__select-company bb-popup-companies" v-click-outside="closePopup">
    <span class="bb-popup-companies__title" v-if="title">
      {{title}}
    </span>
    <div class="bb-popup-companies-body">
      <div class="bb-popup-companies-item"
           v-if="options && options.length > 0"
           v-for="option in options"
           :key="option.id"
           @click="setValue(option)">
        <div class="bb-popup-companies-item__radio" v-if="radio">
          <radio name="clientCompany" :checked="value === option.id"/>
        </div>
        <span class="bb-popup-companies-item__company">{{option.name}}</span>
      </div>
      <div class="bb-popup-companies-item bb-popup-companies-item__text" v-if="content">
        {{content}}
      </div>
    </div>
  </div>
</template>

<script>
import radio from '@/components/Main/Inputs/radio'

export default {
  name: 'Popup',
  props: ['options', 'radio', 'title', 'content', 'value'],
  components: {radio},
  methods: {
    closePopup () {
      this.$emit('close')
    },
    setValue (value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-popup-companies {
    &__title {
      margin-bottom: 8px;
    }

    &-body {
      display: grid;
    }

    &-item {
      display: inline-flex;
      align-items: center;
      margin-bottom: 8px;
      cursor: pointer;

      &:hover {
        color: $color-accent-hover;
      }

      &__radio {
        width: 12px;
        height: 12px;
        display: flex;
        margin-right: 7px;
        align-items: center;
      }

      &__text {
        width: 100%;
        white-space: normal;
        word-break: break-all;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/Popup/Popup.vue